export const LEAD_SOURCE_OPTIONS = [
  { value: '', label: 'All sources' },
  { value: 'calls', label: 'Calls' },
  { value: 'call_center_api', label: 'Call Center API' },
  { value: 'website_form', label: 'Website Form' },
  { value: 'online_chat', label: 'Online Chat' },
] as const

export const LEAD_SOURCE_FORM_OPTIONS = LEAD_SOURCE_OPTIONS.filter((o) => o.value !== '')
